import React from "react";
import { collectionService } from "../../services/collectionService";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import FormLabel from "@material-ui/core/FormLabel";
import { ethers } from "ethers";
import Select from "components/Select/Select";

// @material-ui/icons
import Contacts from "@material-ui/icons/Contacts";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import { Box, Checkbox } from "@material-ui/core";

import styles from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";

import { Controller, useForm } from "react-hook-form";
import { useHistory, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import ImageUpload from "../../components/CustomUpload/ImageUpload";
import { tierName } from "views/RewardTier/const";
import CaseUpload from "components/CustomUpload/CaseUpload";
import { chainOptions } from "../../const";

const useStyles = makeStyles(styles);

const defaultValues = {
  chainId: "25",
  address: "",
  name: "",
  symbol: "",
  isLaunchpad: false,
  tags: false,
  discord: "",
  twitter: "",
  telegram: "",
  website: "",
  description: "",
  image: "",
  cover: "",
  case1: "",
  case2: "",
  case3: "",
};

export default function CollectionCreate() {
  const [valDoxx, setValDoxx] = React.useState(false);
  const [valKyc, setValKyc] = React.useState(false);
  const [valLaunchpad, setValLaunchpad] = React.useState(false);
  const { register: collection, handleSubmit, setValue, control } = useForm({ defaultValues });
  const { id } = useParams();
  const history = useHistory();
  const [rawData, setRawData] = React.useState({});

  async function create(payload) {
    console.log("🍕 ~ payload:", payload);
    try {
      console.log({ payload });
      await setCollectionPayment();
      const { data } = await collectionService.create(payload);
      toast.success("Created");
      window.setTimeout(() => history.push("/admin/collection/" + data._id), 500);
    } catch (e) {
      toast.error(
        e?.response?.data?.message[0] ||
          e?.response?.data?.message ||
          e?.message ||
          "Cannot create",
      );
      console.log(e);
    }
  }

  async function update(payload) {
    try {
      console.log({ update: payload });
      await setCollectionPayment();
      await collectionService.update(id, payload);
      toast.success("Updated successful");
    } catch (e) {
      toast.error(e?.message || e?.response?.data?.message[0] || "Cannot update");
      console.log(e);
    }
  }

  async function setCollectionPayment() {
    const provider = new ethers.providers.Web3Provider(window.ethereum);
    await provider.send("eth_requestAccounts", []);
  }

  async function onSubmit(form) {
    if (id) {
      update(form);
    } else {
      create(form);
    }
  }

  async function fetchCollection() {
    try {
      const { data } = await collectionService.view(id);
      const fields = [
        "name",
        "description",
        "symbol",
        "activated",
        "image",
        "cover",
        "address",
        "payee",
        "royalty",
        "percentage",
        "badge",
        "discord",
        "twitter",
        "telegram",
        "website",
        "tags",
        "featured",
        "isLaunchpad",
        "limit",
        "case1",
        "case2",
        "case3",
        "chainId",
      ];
      fields.forEach((field) => setValue(field, data[field]));
      setRawData(data);
      setValDoxx(data.tags.includes("DOXX") ? true : false);
      setValKyc(data.tags.includes("KYC") ? true : false);
      setValLaunchpad(data.isLaunchpad);
    } catch (e) {
      console.log(e);
    }
  }

  React.useEffect(() => {
    if (id) {
      fetchCollection();
    }
  }, [id]);

  const classes = useStyles();
  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <Card>
          <CardHeader color="rose" icon>
            <CardIcon color="rose">
              <Contacts />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>
              {!id ? "Create Collection" : "Edit Collection"}
            </h4>
          </CardHeader>
          <CardBody>
            <form onSubmit={handleSubmit(onSubmit)}>
              <GridContainer>
                <GridItem xs={12} sm={12} md={8}>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={3}>
                      <FormLabel className={classes.labelHorizontal}>Address</FormLabel>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={7}>
                      <CustomInput
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          type: "text",
                          ...collection("address"),
                        }}
                      />
                    </GridItem>
                  </GridContainer>

                  <GridContainer>
                    <GridItem xs={12} sm={12} md={3}>
                      <FormLabel className={classes.labelHorizontal}>Name</FormLabel>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={7}>
                      <CustomInput
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          type: "text",
                          ...collection("name"),
                        }}
                      />
                    </GridItem>
                  </GridContainer>

                  <GridContainer>
                    <GridItem xs={12} sm={12} md={3}>
                      <FormLabel className={classes.labelHorizontal}>Symbol</FormLabel>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={7}>
                      <CustomInput
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          type: "text",
                          ...collection("symbol"),
                        }}
                      />
                    </GridItem>
                  </GridContainer>

                  <GridContainer>
                    <GridItem xs={12} sm={12} md={3}>
                      <FormLabel className={classes.labelHorizontal}>Launchpad</FormLabel>
                    </GridItem>
                    <GridItem xs={3} sm={3} md={2}>
                      <div style={{ marginTop: "25px" }}>
                        <Checkbox
                          value={valLaunchpad}
                          {...collection("isLaunchpad")}
                          onChange={(e) => {
                            setValLaunchpad(e.target.checked);
                          }}
                          checked={valLaunchpad}
                        />
                      </div>
                    </GridItem>

                    <GridItem xs={3} sm={9} md={5}>
                      {valLaunchpad && (
                        <div
                          style={{
                            display: "flex",
                            gap: "20px",
                          }}
                        >
                          <FormLabel className={classes.labelHorizontal}>Limit</FormLabel>
                          <CustomInput
                            {...collection("limit")}
                            formControlProps={{
                              fullWidth: true,
                            }}
                            inputProps={{
                              type: "number",
                              value: rawData?.limit || 0,
                            }}
                          />
                        </div>
                      )}
                    </GridItem>
                  </GridContainer>

                  <GridContainer>
                    <GridItem xs={12} sm={12} md={3}>
                      <FormLabel className={classes.labelHorizontal}>Royalty</FormLabel>
                    </GridItem>
                    <GridItem xs={3} sm={9} md={5}>
                      <CustomInput
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          disabled: true,
                          type: "text",
                          ...collection("payee"),
                        }}
                      />
                    </GridItem>
                    <GridItem xs={3} sm={3} md={2}>
                      <CustomInput
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          disabled: true,
                          type: "text",
                          value: (rawData?.royalty || 0) / 100,
                        }}
                      />
                    </GridItem>
                  </GridContainer>

                  <GridContainer>
                    <GridItem xs={12} sm={12} md={3}>
                      <FormLabel className={classes.labelHorizontal}>Reward</FormLabel>
                    </GridItem>
                    <GridItem xs={3} sm={9} md={5}>
                      <CustomInput
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          disabled: true,
                          type: "text",
                          value: rawData?.rewardPayee,
                        }}
                      />
                    </GridItem>
                    <GridItem xs={3} sm={3} md={2}>
                      <CustomInput
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          disabled: true,
                          type: "text",
                          value: tierName[rawData?.rewardTier || 0],
                        }}
                      />
                    </GridItem>
                  </GridContainer>

                  <GridContainer>
                    <GridItem xs={12} sm={12} md={3}>
                      <FormLabel className={classes.labelHorizontal}>Badge</FormLabel>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={6}>
                      <Controller
                        control={control}
                        name="badge"
                        render={({ field: { value, onChange } }) => (
                          <Select
                            name="badge"
                            label=" "
                            onChange={onChange}
                            value={value ?? "Unverify"}
                            options={[
                              { value: 1, label: "Verify" },
                              { value: 2, label: "Unverify" },
                              { value: 3, label: "Safe" },
                              { value: 4, label: "CSA" },
                              { value: 5, label: "None" },
                            ]}
                          />
                        )}
                      />
                    </GridItem>
                  </GridContainer>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={3}>
                      <FormLabel className={classes.labelHorizontal}>Chain</FormLabel>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={6}>
                      <Controller
                        control={control}
                        name="chainId"
                        render={({ field: { value, onChange } }) => {
                          console.log("value: ", value);
                          const optionValue = value || "25";
                          console.log(optionValue);

                          return (
                            <Select
                              name="chainId"
                              label=" "
                              onChange={onChange}
                              value={optionValue}
                              options={chainOptions()}
                            />
                          );
                        }}
                      />
                    </GridItem>
                  </GridContainer>

                  <GridContainer>
                    <GridItem xs={12} sm={12} md={3}>
                      <FormLabel className={classes.labelHorizontal}>Tags</FormLabel>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={6}>
                      <div style={{ marginTop: "25px" }}>
                        <Checkbox
                          value={valDoxx ? "DOXX" : ""}
                          {...collection("tags")}
                          onChange={(e) => {
                            setValDoxx(e.target.checked);
                          }}
                          checked={valDoxx}
                        />
                        <span>DOXX</span>{" "}
                        <Checkbox
                          value={valKyc ? "KYC" : ""}
                          {...collection("tags")}
                          onChange={(e) => {
                            setValKyc(e.target.checked);
                          }}
                          checked={valKyc}
                        />{" "}
                        <span>KYC</span>
                      </div>
                    </GridItem>
                  </GridContainer>

                  <GridContainer>
                    <GridItem xs={12} sm={12} md={3}>
                      <FormLabel className={classes.labelHorizontal}>Featured</FormLabel>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={6}>
                      <Controller
                        control={control}
                        name="featured"
                        render={({ field: { value, onChange } }) => (
                          <>
                            <Select
                              name="featured"
                              label=" "
                              onChange={onChange}
                              value={value ?? false}
                              options={[
                                { value: 0, label: "None" },
                                { value: 1, label: "Spot 1" },
                                { value: 2, label: "Spot 2" },
                                { value: 3, label: "Spot 3" },
                                { value: 4, label: "Spot 4" },
                                { value: 5, label: "Spot 5" },
                              ]}
                            />
                          </>
                        )}
                      />
                    </GridItem>
                  </GridContainer>

                  <GridContainer>
                    <GridItem xs={12} sm={12} md={3}>
                      <FormLabel className={classes.labelHorizontal}>Discord</FormLabel>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={7}>
                      <CustomInput
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          type: "text",
                          ...collection("discord"),
                        }}
                      />
                    </GridItem>
                  </GridContainer>

                  <GridContainer>
                    <GridItem xs={12} sm={12} md={3}>
                      <FormLabel className={classes.labelHorizontal}>Twitter</FormLabel>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={7}>
                      <CustomInput
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          type: "text",
                          ...collection("twitter"),
                        }}
                      />
                    </GridItem>
                  </GridContainer>

                  <GridContainer>
                    <GridItem xs={12} sm={12} md={3}>
                      <FormLabel className={classes.labelHorizontal}>Telegram</FormLabel>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={7}>
                      <CustomInput
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          type: "text",
                          ...collection("telegram"),
                        }}
                      />
                    </GridItem>
                  </GridContainer>

                  <GridContainer>
                    <GridItem xs={12} sm={12} md={3}>
                      <FormLabel className={classes.labelHorizontal}>Website</FormLabel>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={7}>
                      <CustomInput
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          type: "text",
                          ...collection("website"),
                        }}
                      />
                    </GridItem>
                  </GridContainer>

                  <GridContainer>
                    <GridItem xs={12} sm={12} md={3}>
                      <FormLabel className={classes.labelHorizontal}>Description</FormLabel>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={7}>
                      <CustomInput
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          type: "text",
                          multiline: true,
                          rows: 4,
                          ...collection("description"),
                        }}
                      />
                    </GridItem>
                  </GridContainer>

                  <GridContainer justify="flex-end">
                    <GridItem xs={12} sm={12} md={3}>
                      <FormLabel className={classes.labelHorizontal}>Is Active</FormLabel>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={9}>
                      <Controller
                        control={control}
                        name="activated"
                        render={({ field: { value, onChange } }) => (
                          <Box pt={5}>
                            <input
                              id={value + "a"}
                              name="activated"
                              type="checkbox"
                              onChange={onChange}
                              checked={value}
                            />
                          </Box>
                        )}
                      />
                    </GridItem>
                  </GridContainer>

                  <GridContainer justify="flex-end">
                    <GridItem xs={12} sm={12} md={9}>
                      <Button onClick={() => history.goBack()}>Cancel</Button>
                      <Button color="rose" type="submit">
                        Submit
                      </Button>
                    </GridItem>
                  </GridContainer>
                </GridItem>

                <GridItem xs={12} sm={12} md={4}>
                  <GridContainer justify="flex-end">
                    <GridItem xs={12} sm={12} md={12}>
                      <p>Image: </p>
                      <Controller
                        control={control}
                        name="image"
                        render={({ field: { value, onChange } }) => (
                          <ImageUpload value={value} onChange={onChange} />
                        )}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                      <p>Cover: </p>
                      <Controller
                        control={control}
                        name="cover"
                        render={({ field: { value, onChange } }) => (
                          <ImageUpload value={value} onChange={onChange} />
                        )}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                      <p>Case: </p>
                      <div className="showcase">
                        <Controller
                          control={control}
                          name="case1"
                          render={({ field: { value, onChange } }) => (
                            <CaseUpload value={value} onChange={onChange} />
                          )}
                        />

                        <Controller
                          control={control}
                          name="case2"
                          render={({ field: { value, onChange } }) => (
                            <CaseUpload value={value} onChange={onChange} />
                          )}
                        />

                        <Controller
                          control={control}
                          name="case3"
                          render={({ field: { value, onChange } }) => (
                            <CaseUpload value={value} onChange={onChange} />
                          )}
                        />
                      </div>
                    </GridItem>
                  </GridContainer>
                </GridItem>

                <GridItem xs={12} sm={12} md={4}></GridItem>
              </GridContainer>
            </form>
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
}
